module.exports = __webpack_public_path__ + "static/media/mc.2f6d3e1b.svg";